// Desc: Configuration for user list headings
const adminUserListHeading = ['name', 'email', 'status', 'actions']
const activeUserListHeading = ['name', 'email', 'type', 'status', 'accessPeriod', 'addedBy', 'permissions', 'actions']
const archiveUserListHeading = [
  'name',
  'email',
  'type',
  'archive',
  'accessPeriod',
  'addedBy',
  'removedBy',
  'permissions'
]

export {adminUserListHeading, activeUserListHeading, archiveUserListHeading}
